export type ProjectSize = "small" | "medium" | "large" | "x-large";

// Every project size is now a tiling of the same base ("small") tile; the size
// selects how many base tiles form the NxN grid that is fanned out to the
// fuel-load workers during initialization. Kept in sync with the backend
// PROJECT_SIZE_GRID_DIMS (api/constants.py).
export const PROJECT_SIZE_GRID_DIM: Record<ProjectSize, number> = {
  small: 1,
  medium: 2,
  large: 4,
  "x-large": 8,
};

// Horizontal (x) / vertical (y) buffer (metres) around the selected lat/lng that
// defines the BASE tile (one "small" project). Larger sizes tile this base.
export const BASE_TILE_METERS = { x: 2500, y: 2500 };

// Retained for legacy callers (e.g. bulk create) that still size a single bbox
// directly. The main wizard uses BASE_TILE_METERS + PROJECT_SIZE_GRID_DIM.
export const PROJECT_SIZE_METERS: Record<ProjectSize, { x: number; y: number }> = {
  small: { x: 2500, y: 2500 },
  medium: { x: 5000, y: 5000 },
  large: { x: 10000, y: 10000 },
  "x-large": { x: 20000, y: 20000 },
};

export const PROJECT_SIZES: ProjectSize[] = [
  "small",
  "medium",
  "large",
  "x-large",
];

export type AspectRatioKey = "1:1" | "2:1" | "1:2";
export const PROJECT_ASPECT_RATIOS: AspectRatioKey[] = ["1:1", "2:1", "1:2"];
